const items = [
  "Saturday, December 5",
  "Sarasota, Florida",
  "Champagne, toasts & dancing",
  "Venez nombreux !",
  "Commencement en direct · December 15",
  "Private dinner at Mila · Miami",
  "In honour of Dr. Stephanie Darilus",
];

const Row = ({ hidden = false }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {items.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-lg italic text-navy-deep sm:text-xl">{item}</span>
        <svg width="11" height="11" viewBox="0 0 14 14" fill="#0B132B" opacity="0.75"><path d="M7 0 L8.8 5.2 L14 7 L8.8 8.8 L7 14 L5.2 8.8 L0 7 L5.2 5.2 Z" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="marquee-band" className="relative overflow-hidden border-y border-gold-deep/40 bg-gradient-to-r from-gold-deep via-gold to-gold-deep py-4">
    <div className="animate-marquee flex w-max">
      <Row />
      <Row hidden />
    </div>
  </div>
);
